<script setup>
import { ref } from "vue";

const props = defineProps(["value"]);

const copied = ref(false);

function copy() {
	navigator.clipboard.writeText(props.value).then(() => (copied.value = true));
}
</script>

<template>
	<button class="vui-copy-btn vui-btn icon" :title="$gettext('Copy URL to clipboard')" @click="copy()">
		<i :class="copied ? 'fa-check' : 'fa-copy'" class="fa-regular fa-fw" @transitionend="copied = false"></i>
	</button>
</template>
